import { createFileRoute } from "@tanstack/react-router";

import { PayoutPage } from "../../../../features/shipping/payout-page";

export const Route = createFileRoute("/_app/payments/cod/$id")({ component: Payout });

function Payout() {
  const { id } = Route.useParams();
  return <PayoutPage key={id} id={id} />;
}
